import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import 'antd/dist/reset.css';
import App from './App';
import './auth/amplifyConfig';
import { antTheme } from './theme/brand';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider theme={antTheme}>
      <BrowserRouter>
        <Authenticator.Provider>
          <App />
        </Authenticator.Provider>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>,
);
